<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">Dodaj uprawnienie</v-flex>

    <div>
      <v-autocomplete v-model="selected" clearable label="Uprawnienie" :items="list" @change="saveToSchema" />
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { mapState } from 'vuex';

import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/rolePermission.schema';

const emptyData = () => ({
  permissionId: null,
  roleId: null
});
// @vuese
// Modal do dodawania/edycji uprawnień
// @group Roles
export default {
  data() {
    return {
      selected: undefined
    };
  },
  components: { modal },
  schema,
  computed: {
    ...mapState({
      list: state =>
        state.permissions.list
          .filter(perm => !state.roles.rolePermission.list.some(rolePerm => rolePerm.permission.id === perm.id))
          .map(perm => ({ value: perm.id, text: perm.name }))
    })
  },
  mixins: [manageMixin('permissions', {}, emptyData)],

  methods: {
    // @vuese
    // Pobieranie listy uprawnień
    getPermissions() {
      this.$store.dispatch(`permissions/list`, { count: 0 }).catch(err =>
        this.$store.dispatch('notifyError', {
          title: 'Wystąpił błąd podczas pobierania listy uprawnień'
        })
      );
    },
    // @vuese
    // Ustawia dane formularza
    setData() {
      this.$schema.$setData(emptyData());
      this.$schema.$reset();
      this.$schema.roleId.$model = parseInt(this.$route.params.id);
      this.selected = undefined;
    },
    // @vuese
    // Zapisuje do schema
    saveToSchema(id) {
      this.$schema.permissionId.$model = id;
    }
  },
  mounted() {
    this.getPermissions();
  }
};
</script>
